module.exports = [{
      plugin: require('/codebuild/output/src769596612/src/vowtch-registration-portal/node_modules/gatsby-plugin-typography/gatsby-browser'),
      options: {"plugins":[]},
    },{
      plugin: require('/codebuild/output/src769596612/src/vowtch-registration-portal/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
